import { motion } from "framer-motion";
import { Clock, Gift, ShieldCheck, ArrowUpRight } from "lucide-react";
import { CONTACT } from "@/data/content";

const WhatsappIcon = ({ size = 22 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413" />
  </svg>
);

const CHIPS = [
  { icon: Clock, label: "30 minutos" },
  { icon: Gift, label: "100% gratis" },
  { icon: ShieldCheck, label: "Sin compromiso" },
];

const bookWa = `${CONTACT.whatsapp}?text=${encodeURIComponent(
  "¡Hola isavicente! Quiero agendar mi asesoría gratuita de 30 minutos."
)}`;

export const BookingCTA = () => {
  return (
    <section
      id="cita"
      data-testid="booking-section"
      className="max-w-[1400px] mx-auto px-5 sm:px-8 py-16 md:py-24"
    >
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="relative overflow-hidden rounded-[2rem] bg-forest text-cream p-8 sm:p-12 md:p-16"
      >
        <div className="noise-overlay absolute inset-0 opacity-[0.12] pointer-events-none" />
        <div className="absolute -top-24 -right-16 h-80 w-80 rounded-full bg-mango/20 blur-3xl" />
        <div className="absolute -bottom-28 -left-10 h-80 w-80 rounded-full bg-green/20 blur-3xl" />

        <div className="relative">
          <p className="text-xs font-bold tracking-[0.25em] uppercase text-mango mb-5">
            Asesoría gratuita
          </p>
          <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.92] max-w-3xl">
            Agenda tu asesoría de{" "}
            <span className="text-mango">30 minutos</span>, gratis y sin compromiso.
          </h2>
          <p className="mt-6 text-cream/70 text-base md:text-lg max-w-xl leading-relaxed">
            Cuéntame dónde está tu marca y qué quieres conseguir. Analizamos juntas
            tu situación y te propongo por dónde empezar. Sin coste y sin ataduras.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            {CHIPS.map((c) => (
              <span
                key={c.label}
                className="inline-flex items-center gap-2 rounded-full bg-cream/10 border border-cream/20 px-4 py-2 text-sm font-semibold"
              >
                <c.icon size={16} className="text-green" />
                {c.label}
              </span>
            ))}
          </div>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href={bookWa}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="booking-whatsapp-btn"
              className="group inline-flex items-center justify-center gap-3 rounded-full bg-green text-ink font-bold text-base px-7 py-4 hover:brightness-95 transition-all"
            >
              <WhatsappIcon size={22} />
              Agendar por WhatsApp
            </a>
            <a
              href={`mailto:${CONTACT.email}?subject=${encodeURIComponent("Asesoría gratuita 30 min")}`}
              data-testid="booking-email-btn"
              className="group inline-flex items-center justify-center gap-2 rounded-full border border-cream/30 text-cream font-bold text-base px-7 py-4 hover:bg-cream/10 transition-colors"
            >
              Escribir por email
              <ArrowUpRight size={20} className="group-hover:rotate-45 transition-transform duration-300" />
            </a>
          </div>
        </div>
      </motion.div>
    </section>
  );
};
